import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";
import es from "vuetify/lib/locale/es";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#117f9c",
        secondary: "#545454",
        accent: colors.shades.black,
        error: colors.red.darken2,
      },
      dark: {
        primary: colors.blue.darken3,
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
});
export default vuetify;
